module.exports = function getResource(label, vars = []) {
    let resources = {
        checkoutPickupItems: 'Articles à ramasser',
        checkoutShippedItems: 'Articles à faire livrer',
        freeShippingModalTitle: 'Obtenir la livraison en 2 jours GRATUITE',
        freeShippingModalBody1: 'Vous êtes admissible à un abonnement GRATUIT à Sephora FLASH à titre de *cadeau de célébration Rouge*. Rendez-vous à votre',
        beautyInsiderPageText: 'page Beauty Insider',
        freeShippingModalBody2: 'pour en savoir plus.',
        freeShippingModalButtonText: 'OK',
        merchandiseSubtotalText: 'Sous-total des marchandises',
        discountsText: 'Réductions',
        shippingAndHandlingText: 'Expédition et manutention',
        pickupText: 'Ramassage',
        free: 'GRATUIT',
        tbdText: 'À déterminer',
        gstHstText: 'TPS/TVH',
        taxText: 'Taxe',
        estimatedTotalText: 'Total estimé ',
        shippingAndTaxesText: 'L’expédition et les taxes seront calculées à la caisse',
        shippingHandlingInfo: 'Renseignements sur l’expédition et la manutention',
        salesTax: 'Taxe de vente',
        item: 'article',
        items: 'articles',
        pointsUsed: 'Utilisé',
        accountCredit: 'Crédit au compte',
        bagFee: 'Frais de sac',
        specialFee: 'Frais spécial',
        gotIt: 'Compris',
        continueToCheckout: 'Passer à la caisse'
    };

    return resources[label];
};
